import { IoMdMore } from "react-icons/io";

const DepartmentItem = (props: any) => (
  <div className="rounded-lg  border border-gray-300 my-2  flex justify-between  py-4 ">

    <div className=" px-4">

    <p className="font-bold text-textbg text-xs ">{props.item.deptName}</p>
    <p className="font-light px-2  text-xs">{props.item.description}</p> 
    <p className="font-light px-2 bg-faintBlue text-xs my-2 w-14 rounded">{props.item.status}</p> 
    </div>
    <IoMdMore size={20} className="text-textbg mr-3"/>
  </div>
);

export { DepartmentItem };
